import React from "react";
import { useTranslation } from "react-i18next";
import { OcConfirmationDialog } from "oc/components";

type MyTimeCloseConfirmationDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const MyTimeCloseConfirmationDialog = ({
  open,
  onConfirm,
  onCancel,
}: MyTimeCloseConfirmationDialogProps) => {
  const { t } = useTranslation();
  return (
    <OcConfirmationDialog
      showDialog={open}
      title={t("MY_TIME_CONFIRM_CLOSE_MONTH_TITLE")}
      texts={[t("MY_TIME_CONFIRM_CLOSE_MONTH_TEXT")]}
      okButtonText={t("MY_TIME_CLOSE_MONTH")}
      cancelButtonText={t("OC_CANCEL")}
      onClose={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default MyTimeCloseConfirmationDialog;
